import { render, staticRenderFns } from "./paging.vue?vue&type=template&id=7bbe000f"
import script from "./paging.vue?vue&type=script&lang=ts"
export * from "./paging.vue?vue&type=script&lang=ts"
import style0 from "./paging.vue?vue&type=style&index=0&id=7bbe000f&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bbe000f')) {
      api.createRecord('7bbe000f', component.options)
    } else {
      api.reload('7bbe000f', component.options)
    }
    module.hot.accept("./paging.vue?vue&type=template&id=7bbe000f", function () {
      api.rerender('7bbe000f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/paging/paging.vue"
export default component.exports